import { render, staticRenderFns } from "./ActiveList.vue?vue&type=template&id=6a0dfb07&scoped=true&"
import script from "./ActiveList.vue?vue&type=script&lang=js&"
export * from "./ActiveList.vue?vue&type=script&lang=js&"
import style0 from "./ActiveList.vue?vue&type=style&index=0&id=6a0dfb07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0dfb07",
  null
  
)

export default component.exports